import { render, staticRenderFns } from "./PQRInfoCard.vue?vue&type=template&id=f421409a"
import script from "./PQRInfoCard.vue?vue&type=script&lang=js"
export * from "./PQRInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports